import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import RemoteSourceTable from 'components/tables/data/remote-source/RemoteSourceTable';
import { useMemo } from 'react';

/**
 * Page used to list remote sources.
 */
export default function RemoteSourcesPage() {
  const breadcrumbs = useMemo(() => [{ title: 'Externé zdroje' }], []);

  return (
    <DashboardLayout height="screen" breadcrumbs={breadcrumbs}>
      <RemoteSourceTable />
    </DashboardLayout>
  );
}
